import Feedback from '../feedback';

/**
 * Create the action
 */

const { thunk, request, success, error } = Feedback.store((data, fetch) => {
    return fetch.post('/feedback', data);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
